document.addEventListener('DOMContentLoaded', function () {
    // MutationObserver einrichten, um Änderungen im DOM zu überwachen
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function () {
            const availableProductsContainers = document.querySelectorAll('.bndlr-mnm-available-products');

            if (availableProductsContainers.length > 0) {
                observer.disconnect(); // Stoppe den Observer, wenn die Elemente gefunden wurden

                availableProductsContainers.forEach(container => {
                    const productLinks = container.querySelectorAll('.bndlr-product-image-url');

                    productLinks.forEach(link => {
                        // Entferne nur `.bndlr-product-qn-container`, die Geschwister des `a`-Links sind
                        const siblingContainers = Array.from(link.parentNode.children).filter(
                            sibling =>
                                sibling.classList.contains('bndlr-product-qn-container') &&
                                sibling !== link.querySelector('.bndlr-product-qn-container')
                        );

                        siblingContainers.forEach(sibling => sibling.remove());

                        // Prüfe, ob im aktuellen `a`-Element bereits ein neuer Container existiert
                        const existingContainer = link.querySelector('.bndlr-product-qn-container');
                        if (existingContainer) {
                            return; // Überspringe, wenn der Container bereits existiert
                        }

                        // Neuen Container erstellen
                        const qnContainer = document.createElement('div');
                        qnContainer.className = 'bndlr-product-qn-container';

                        const imgElement = link.querySelector('img');
                        const productTitle = document.createElement('a');
                        productTitle.href = link.href;
                        productTitle.className = 'bndlr-product-title';
                        productTitle.target = '_blank';
                        productTitle.title = imgElement ? imgElement.title : 'No title';
                        productTitle.textContent = imgElement ? imgElement.title : 'No title';

                        // Füge den Titel in den neuen Container ein
                        qnContainer.appendChild(productTitle);

                        // Positioniere den neuen Container
                        qnContainer.style.position = 'absolute';
                        qnContainer.style.bottom = '0';
                        qnContainer.style.left = '0';
                        qnContainer.style.width = '100%';
                        qnContainer.style.minHeight = '60px';
                        qnContainer.style.display = 'flex';
                        qnContainer.style.alignItems = 'center';
                        qnContainer.style.justifyContent = 'center';
                        qnContainer.style.backgroundColor = 'rgba(0, 0, 0, 0.3)';
                        qnContainer.style.padding = '2px 6px';
                        qnContainer.style.borderRadius = '3px';
                        qnContainer.style.fontSize = '12px';
                        qnContainer.style.zIndex = '10';

                        // Sicherstellen, dass das `a`-Element relativ positioniert ist
                        link.style.position = 'relative';

                        // Füge den neuen Container in das `a`-Element ein
                        link.appendChild(qnContainer);
                    });
                });
            }
        });
    });

    // Beobachte Änderungen im gesamten DOM
    observer.observe(document.body, {
        childList: true, // Beobachte, ob neue Kinder hinzugefügt oder entfernt werden
        subtree: true // Beobachte auch alle Unterknoten des `body`
    });
});
